import { render } from "./ReportLotDepartures.vue?vue&type=template&id=e552bd1e&scoped=true"
import script from "./ReportLotDepartures.vue?vue&type=script&lang=js"
export * from "./ReportLotDepartures.vue?vue&type=script&lang=js"

import "./ReportLotDepartures.vue?vue&type=style&index=0&id=e552bd1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e552bd1e"]])

export default __exports__